import axios from 'axios';
import { API } from '../constants';

export const TOKEN_KEY = 'bk_admin_token';

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setAdminToken = (token) => (token ? localStorage.setItem(TOKEN_KEY, token) : localStorage.removeItem(TOKEN_KEY));

const client = axios.create({ baseURL: `${API}/admin` });
client.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const onUnauthorized = (handler) => {
  client.interceptors.response.use((r) => r, (error) => {
    if (error.response?.status === 401) handler();
    return Promise.reject(error);
  });
};

export const apiError = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(' ');
  return error.message || 'Errore inatteso';
};

export const adminLogin = (email, password) => client.post('/login', { email, password }).then((r) => r.data);
export const adminMe = () => client.get('/me').then((r) => r.data);
export const fetchStats = () => client.get('/orders/stats').then((r) => r.data);
export const fetchOrders = (params) => client.get('/orders', { params }).then((r) => r.data);
export const fetchOrder = (id) => client.get(`/orders/${id}`).then((r) => r.data);
export const fetchCarriers = () => client.get('/carriers').then((r) => r.data);
export const updateStatus = (id, status, note = '') => client.patch(`/orders/${id}/status`, { status, note }).then((r) => r.data);
export const saveShipment = (id, payload) => client.put(`/orders/${id}/shipment`, payload).then((r) => r.data);
export const saveContact = (id, customer, shipping_address) => client.put(`/orders/${id}/contact`, { customer, shipping_address }).then((r) => r.data);
export const saveNotes = (id, notes) => client.patch(`/orders/${id}/notes`, { notes }).then((r) => r.data);
export const resendEmail = (id, kind) => client.post(`/orders/${id}/emails/${kind}`).then((r) => r.data);
